import httpService from '@/modules/common/services/httpService';

// TODO: should I use the implementation utils/backwardCompatibility/accountModule/services/accountService.js ?
// Note: This api is lightweight, other parts of the profile controller should not be added without checking the impact on performance.
const getGeoDataByIP = () => httpService.get('/v2/profile/geo_data_by_ip').then((res) => res.data);

export default {
  getGeoDataByIP,
};
